import {
    useStytchB2BClient,
    useStytchMember,
    useStytchMemberSession,
    useStytchOrganization,
} from "@stytch/react/b2b";
import { Link } from "react-router-dom";
import React from "react";
import { Box, Grid } from "@mui/joy";

export default function Debug() {
    const client = useStytchB2BClient();
    const { member } = useStytchMember();
    const { session } = useStytchMemberSession();
    const { organization } = useStytchOrganization();

    return (
        <Grid container spacing={2} sx={{ flexGrow: 1, m: 1 }}>
            <Grid md={8}>
                <Box sx={{ width: "100%" }}>
                    {member ? (
                        <div className="debug">
                            <p>Member Debug</p>
                            <pre>{JSON.stringify(member, null, 2)}</pre>

                            <p>Session</p>
                            <pre>{JSON.stringify(session, null, 2)}</pre>

                            <p>Organization</p>
                            <pre>{JSON.stringify(organization, null, 2)}</pre>
                        </div>
                    ) : (
                        <p>
                            Not logged in. <Link to="/authenticate">Login</Link>
                        </p>
                    )}
                </Box>
            </Grid>

            <Grid md={4}>
                <Box
                    sx={{
                        backgroundColor: "blue",
                    }}
                >
                    {session && (
                        <p>
                            <strong>Logged in!</strong>
                            <button onClick={() => client.session.revoke()}>Logout</button>
                        </p>
                    )}
                </Box>
            </Grid>
        </Grid>
    );
}
